exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".roles-form div>h4{margin-bottom:10px}.roles-form .panel{margin-bottom:10px;cursor:pointer}.roles-form .modulo:hover .panel-heading{color:#000;background-color:#fffdf4}.roles-form fieldset h6{margin-bottom:10px;color:rgba(0,0,0,.7);text-align:right}.roles-form .panel-heading h4,.roles-form .panel-heading h5{display:inline}.roles-form .panel-heading h5{margin:0}.roles-form .panel-heading h5>span{background:#008fe2;opacity:.6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/roles/form/form.scss
// module id = 995
// module chunks = 0